var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable max-lines */
import { useEffect, useState } from 'react';
import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { isEqual } from 'lodash';
import { updateSearch } from 'bernie-core';
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from '@egds/react-core/layout-flex';
import { EGDSLoader } from '@egds/react-core/loader';
import { Level, liveAnnounce } from '@egds/react-core/utils';
import { PRICE_REQUEST_CALIFORNIA_SUBMITTED } from 'src/common/constants/analytics';
import { PROPERTY_LISTING_BATCH_KEY } from 'src/common/constants/batchKeys';
import { isVrbo } from 'src/common/stores/context-store-utils';
import { useDynamicSearchMapContext } from 'src/common/stores/contexts/map/dynamic-search-map-context';
import { useRefProvider } from 'src/common/stores/contexts/ref-provider';
import { SrpTemplate } from 'src/common/stores/page-layout/page-layout-store-utils';
import { isCompressionBannerMessageDismissed, setCompressionBannerDismiss } from 'src/common/utils/compression-banner-utils';
import { isMobile, isMobileOrTablet, isTablet } from 'src/common/utils/is-mobile';
import { handleFilterPillRemoval, handleRemoveAllFilters } from 'src/common/utils/property-listing-utils';
import { updateCategorySearchQueryParam } from 'src/common/utils/query-params-util';
import { onClickScrollToTarget } from 'src/common/utils/smooth-scroll';
import { useEgClickstream } from '@shared-ui/clickstream-analytics-context';
import { useExperiment } from '@shared-ui/experiment-context';
import { useLocalization } from '@shared-ui/localization-context';
import { PropertyListing } from '@shared-ui/lodging-property-listing';
import { useRefContext } from '@shared-ui/ref-context';
import { SearchFormSignalsMap } from '@shared-ui/retail-search-tools-lodging';
import { getPropertySearchInputWithSearchId } from 'stores/adapters';
import { getDateFlexibility } from '../../common/universal-search-form/universal-search-form-utils';
import { preloadPdpHeroImage } from './preload-pdp-hero-image';
import { usePropertyName } from './use-pdp-hero-image-url';
import useSecondaryFetchStatus from './use-secondary-fetch-status-hook';
export const PropertyListingWrapper = inject('context', 'multiItem', 'uiPage', 'currentHotel', 'searchCriteria', 'searchResults', 'experiment', 'analytics', 'pageLayout', 'analyticsSearch')(observer(({
  analytics,
  context,
  uiPage,
  multiItem,
  currentHotel,
  searchCriteria,
  searchResults,
  experiment,
  searchInputs,
  criteriaChanged,
  pageLayout,
  analyticsSearch,
  handleNext,
  handlePrev
}) => {
  var _a, _b;
  const {
    formatText
  } = useLocalization();
  const [inputs, setInputs] = useState(searchInputs);
  const {
    getTargets
  } = useRefContext();
  const {
    SearchForm: searchFormRef
  } = getTargets(['SearchForm']);
  const location = useLocation();
  const history = useHistory();
  const {
    setHighlightedPropertyId
  } = useDynamicSearchMapContext();
  const {
    exposure: akamaiSmartCroppingExposure
  } = useExperiment('Akamai_smart_cropping_for_PDP_image_gallery');
  const {
    exposure: mWebLargeImageExposure
  } = useExperiment('mWeb_larger_image_for_top_of_PDP_gallery');
  const {
    exposure: preloadPdpHeroOnCardHoverExposure,
    logExperiment: preloadPdpHeroOnCardHoverExperiment
  } = useExperiment('Preload_hero_image_on_SRP_card_hover');
  const {
    exposure: propertyDetailsQueryCsrExposure
  } = useExperiment('PropertyDetailsQuery_CSR');
  const [loadedLiveAnnounce, setLoadedLiveAnnounce] = useState('');
  const isSplitView = (pageLayout === null || pageLayout === void 0 ? void 0 : pageLayout.templateName) === SrpTemplate.SplitView;
  const usePropertyListingQuery = !(multiItem === null || multiItem === void 0 ? void 0 : multiItem.isPackageShoppingPath());
  const {
    appendPropertyNameUrlParam
  } = usePropertyName();
  const track = useEgClickstream();
  useEffect(() => {
    var _a, _b, _c, _d;
    const additionalEvents = (_b = (_a = searchResults === null || searchResults === void 0 ? void 0 : searchResults.clickstreamEvents) === null || _a === void 0 ? void 0 : _a.additionalEvents) !== null && _b !== void 0 ? _b : [];
    if (additionalEvents.length) {
      const californiaAnalyticsPayload = additionalEvents.find(element => {
        var _a, _b;
        try {
          return Object.hasOwn((_b = (_a = JSON.parse(element)) === null || _a === void 0 ? void 0 : _a.events) !== null && _b !== void 0 ? _b : {}, PRICE_REQUEST_CALIFORNIA_SUBMITTED);
        } catch (error) {
          return false;
        }
      });
      if (californiaAnalyticsPayload) {
        const analyticPayloads = JSON.parse(californiaAnalyticsPayload);
        const priceRequestCaliforniaSubmittedEvent = (_d = (_c = analyticPayloads.events[PRICE_REQUEST_CALIFORNIA_SUBMITTED]) === null || _c === void 0 ? void 0 : _c.v1) === null || _d === void 0 ? void 0 : _d.event_data;
        if (priceRequestCaliforniaSubmittedEvent !== null && priceRequestCaliforniaSubmittedEvent !== undefined) {
          track(priceRequestCaliforniaSubmittedEvent);
        }
      }
    }
  }, [searchResults === null || searchResults === void 0 ? void 0 : searchResults.clickstreamEvents]);
  useEffect(() => {
    if (criteriaChanged) {
      setInputs(searchInputs);
    }
  }, [criteriaChanged]);
  if (!context || !searchCriteria || !(searchResults === null || searchResults === void 0 ? void 0 : searchResults.searchCriteria) || !analyticsSearch || !experiment) return null;
  const multiItemContext = (multiItem === null || multiItem === void 0 ? void 0 : multiItem.multiItemContext) || null;
  const showLoadingSpinner = useSecondaryFetchStatus({
    searchResults,
    context,
    multiItem,
    uiPage,
    analytics,
    experiment,
    analyticsSearch,
    pageLayout
  });
  const onRemoveAllFilters = action => handleRemoveAllFilters(action, analytics, history);
  const openDatepicker = React.useCallback(() => {
    uiPage === null || uiPage === void 0 ? void 0 : uiPage.dispatchOpenNewDatePickerEvent();
  }, [uiPage]);
  const changeFlexibility = React.useCallback(flexibility => {
    var _a, _b;
    let currentFlexibilityParams = typeof searchCriteria.flexibility === 'string' ? [searchCriteria.flexibility] : searchCriteria.flexibility;
    // This could be a MobX "array", so it gets converted to a real one for comparison
    if (currentFlexibilityParams) {
      currentFlexibilityParams = [...currentFlexibilityParams];
    }
    const newFlexibilityParams = getDateFlexibility(flexibility);
    if (!isEqual(currentFlexibilityParams, newFlexibilityParams)) {
      (_a = searchFormRef === null || searchFormRef === void 0 ? void 0 : searchFormRef.current) === null || _a === void 0 ? void 0 : _a.focus();
      (_b = searchFormRef === null || searchFormRef === void 0 ? void 0 : searchFormRef.current) === null || _b === void 0 ? void 0 : _b.scrollIntoView({
        behavior: 'smooth'
      });
      const newParamsObject = new URLSearchParams();
      newFlexibilityParams.forEach(param => newParamsObject.append('flexibility', param));
      updateSearch({
        location,
        history,
        newParams: newParamsObject.toString()
      });
    }
  }, [history, location, searchCriteria.flexibility, searchFormRef]);
  const batchKey = ((_b = (_a = experiment === null || experiment === void 0 ? void 0 : experiment.exposures) === null || _a === void 0 ? void 0 : _a.SHOPPING_PWA_BATCHING_SRP_QUERY) === null || _b === void 0 ? void 0 : _b.bucket) === 1 ? PROPERTY_LISTING_BATCH_KEY : undefined;
  // Temporarily passing the PWA search listings response to the shared UI component to avoid duplicating the
  // request for search listings on SRP. Once we migrate the listings fetch to shared UI this will be cleaned up.
  const isLoadingPwa = searchResults.isLoading || searchResults.isPaginationLoading;
  const loadMessage = formatText('hotels.searchResults.resultsLoading.liveAnnounce');
  const errorMessage = formatText('hotels.searchResults.errorRetrievingResults.liveAnnounce');
  const updateMessage = formatText('hotels.searchResults.resultsUpdated.liveAnnounce');
  const shouldChangeCardDisplayOnHover = !isMobileOrTablet(context) && isVrbo(context);
  const onFilterPillRemoval = pill => handleFilterPillRemoval(pill, history);
  // useMemo will prevent re-rendering listing and map components when mouse pointer is hovering
  const searchListingsProps = React.useMemo(() => {
    if (usePropertyListingQuery) {
      return {
        inputs,
        listingAnnouncementMessages: {
          loadMessage: loadMessage,
          errorMessage: errorMessage,
          updateMessage: updateMessage
        },
        data: {
          propertySearchListings: searchResults.propertySearchListings,
          pagination: searchResults.pagination,
          summary: {
            resultMessages: searchResults.resultMessages,
            resultsHeading: searchResults.resultsHeading,
            loyaltyInfo: searchResults.loyaltyMessagingModel,
            // TODO: review loyaltyInfo mapping
            shoppingJoinListContainer: searchResults.shoppingJoinListContainer,
            // missing: __typename, matchedPropertiesSize
            header: searchResults.header
          },
          mapTrigger: searchResults.mapTrigger,
          errorResponse: searchResults.errorResponse,
          dialogErrorResponse: searchResults.dialogErrorResponse,
          criteria: searchResults.searchCriteria,
          propertyListingsToast: searchResults.propertyListingToast,
          propertyListingAdaptexAnalyticsSuccessEvents: searchResults.propertyListingAdaptexAnalyticsSuccessEvents
        },
        isLoadingPwa,
        propertySearchListingsPwa: searchResults.propertySearchListings,
        locationFieldUpdateSignalType: SearchFormSignalsMap.LOCATION_FIELD_UPDATE,
        onFilterPillRemoval,
        onRemoveAllFilters
      };
    }
    const _a = getPropertySearchInputWithSearchId(context, analyticsSearch, searchResults.searchCriteria, multiItemContext),
      {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        context: bexApiContext
      } = _a,
      propertyListingControlInputs = __rest(_a, ["context"]);
    return {
      data: searchResults.header && {
        summary: {
          header: searchResults.header
        }
      },
      inputs: propertyListingControlInputs,
      isLoadingPwa,
      propertyListingToast: searchResults.propertyListingToast,
      propertySearchListingAdaptexAnalyticsEvents: searchResults.propertyListingAdaptexAnalyticsSuccessEvents,
      propertySearchListingsPwa: searchResults.propertySearchListings
    };
  }, [context, inputs, multiItemContext, searchResults.isLoading, searchResults.isPaginationLoading, searchResults.propertyListingToast, searchResults.propertyListingAdaptexAnalyticsSuccessEvents, searchResults.propertySearchListings, searchResults.searchCriteria, usePropertyListingQuery]);
  const [searchResultsListRef] = useRefProvider('searchResultsList');
  const handleClickCallback = React.useCallback(lodgingCard => {
    currentHotel === null || currentHotel === void 0 ? void 0 : currentHotel.setPropertyListingAsCurrentHotel(lodgingCard);
    const deviceProps = {
      isMobile: isMobile(context),
      isTablet: isTablet(context)
    };
    const akamaiSmartCroppingVariant = akamaiSmartCroppingExposure.bucket;
    const mWebLargerImageVariant = mWebLargeImageExposure.bucket;
    const propertyDetailsQueryCsrVariant = propertyDetailsQueryCsrExposure.bucket;
    if (preloadPdpHeroOnCardHoverExposure.bucket === 0) {
      preloadPdpHeroImage(lodgingCard, deviceProps, akamaiSmartCroppingVariant, mWebLargerImageVariant, propertyDetailsQueryCsrVariant);
    }
  }, [currentHotel, context, akamaiSmartCroppingExposure.bucket, mWebLargeImageExposure.bucket, preloadPdpHeroOnCardHoverExposure.bucket]);
  const handleCategoryCarouselImageCardClick = React.useCallback(categoryImageCard => {
    analyticsSearch.withPublishingAnalyticsPayload(updateSearch, analytics, experiment)({
      history,
      location,
      newParams: updateCategorySearchQueryParam(categoryImageCard, location),
      replace: false,
      queryCombiner: (_prevQuery, newQuery) => newQuery
    });
    /*
      Scroll to the top of the page after any interaction with the category image tabs,
      The category carousel is then displayed above the property listing after selecting a category card from the list.
    */
    onClickScrollToTarget({
      scrollTo: 0
    });
  }, [history, location, updateSearch, analytics, analyticsSearch, experiment]);
  const handleHoverChange = React.useCallback((hovered, data) => {
    var _a;
    if (isSplitView) {
      const cardId = (_a = data === null || data === void 0 ? void 0 : data.id) !== null && _a !== void 0 ? _a : '';
      setHighlightedPropertyId(hovered ? cardId : '');
    }
    const deviceProps = {
      isMobile: isMobile(context),
      isTablet: isTablet(context)
    };
    const akamaiSmartCroppingVariant = akamaiSmartCroppingExposure.bucket;
    const mWebLargerImageVariant = mWebLargeImageExposure.bucket;
    const propertyDetailsQueryCsrVariant = propertyDetailsQueryCsrExposure.bucket;
    preloadPdpHeroOnCardHoverExperiment(preloadPdpHeroOnCardHoverExposure);
    if (preloadPdpHeroOnCardHoverExposure.bucket === 1) {
      hovered && preloadPdpHeroImage(data, deviceProps, akamaiSmartCroppingVariant, mWebLargerImageVariant, propertyDetailsQueryCsrVariant);
    }
  }, [setHighlightedPropertyId]);
  const handlePaginationCallback = isSplitView ? React.useCallback(paginationSubSets => {
    searchCriteria.paginationSubSets = paginationSubSets;
  }, [searchCriteria]) : undefined;
  const handleDestinationCallback = React.useCallback(destination => {
    searchCriteria.pageTitle = destination;
  }, []);
  liveAnnounce(loadedLiveAnnounce, Level.POLITE);
  useEffect(() => {
    if (!usePropertyListingQuery) {
      if (isLoadingPwa) {
        setLoadedLiveAnnounce(loadMessage);
      } else {
        setLoadedLiveAnnounce(updateMessage);
      }
    }
  }, [isLoadingPwa, loadMessage, updateMessage, usePropertyListingQuery]);
  const handleBannerDismiss = React.useCallback(() => {
    setCompressionBannerDismiss(true);
  }, [setCompressionBannerDismiss]);
  return React.createElement(React.Fragment, null, React.createElement(MemoizedPropertyListing, Object.assign({}, searchListingsProps, {
    batchKey: batchKey,
    openDatePicker: openDatepicker,
    onClickCallback: handleClickCallback,
    onHoverChanged: handleHoverChange,
    appendAdditionalQueryParamCb: appendPropertyNameUrlParam,
    onPaginationCallback: handlePaginationCallback,
    onDestinationCallback: handleDestinationCallback,
    shouldScrollToTopOnSearch: isSplitView && !searchResults.isScrollToTopOnSearchDisabled,
    scrollToTopRef: searchResultsListRef,
    changeFlexibility: changeFlexibility,
    shouldChangeCardDisplayOnHover: shouldChangeCardDisplayOnHover,
    onBannerDismiss: handleBannerDismiss,
    hideCompressionMessage: isCompressionBannerMessageDismissed(),
    onPaginationNext: handleNext,
    onPaginationPrev: handlePrev,
    showPagination: usePropertyListingQuery,
    showLoadingSpinner: usePropertyListingQuery && showLoadingSpinner,
    showListingToast: true,
    onImageCardClickCallback: handleCategoryCarouselImageCardClick
  })), !usePropertyListingQuery && showLoadingSpinner && React.createElement(EGDSLayoutFlex, {
    justifyContent: "center"
  }, React.createElement(EGDSLayoutFlexItem, null, React.createElement(EGDSLoader, null))));
}));
PropertyListingWrapper.displayName = 'PropertyListingWrapper';
const MemoizedPropertyListing = React.memo(PropertyListing);